/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGame } from './OWGame';
import {
    OWGameFromJSON,
    OWGameFromJSONTyped,
    OWGameToJSON,
    OWGameToJSONTyped,
} from './OWGame';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface GetOverwolfGamesResponse
 */
export interface GetOverwolfGamesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetOverwolfGamesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<OWGame>}
     * @memberof GetOverwolfGamesResponse
     */
    games: Array<OWGame>;
}

/**
 * Check if a given object implements the GetOverwolfGamesResponse interface.
 */
export function instanceOfGetOverwolfGamesResponse(value: object): value is GetOverwolfGamesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('games' in value) || value['games'] === undefined) return false;
    return true;
}

export function GetOverwolfGamesResponseFromJSON(json: any): GetOverwolfGamesResponse {
    return GetOverwolfGamesResponseFromJSONTyped(json, false);
}

export function GetOverwolfGamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOverwolfGamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'games': ((json['games'] as Array<any>).map(OWGameFromJSON)),
    };
}

export function GetOverwolfGamesResponseToJSON(json: any): GetOverwolfGamesResponse {
    return GetOverwolfGamesResponseToJSONTyped(json, false);
}

export function GetOverwolfGamesResponseToJSONTyped(value?: GetOverwolfGamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'games': ((value['games'] as Array<any>).map(OWGameToJSON)),
    };
}

